import { useTranslation } from 'react-i18next';
import { useLogout } from '@/hooks/useLogout';
import { classicUrl } from '@/utils/classicLinks';

// TODO (EPT-8329: hardcoded id - update this when we have access to mappings)
const DEFAULT_COMPETITION_ID = 1002;

export const useAccountNavigationItems = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation(['navigation']);
  const logout = useLogout();

  return [
    {
      id: 'default-team',
      label: t('crossPlatform.secondary.defaultTeam'),
      route: classicUrl('personalisation/my-default-team'),
    },
    {
      id: 'favorites',
      label: t('crossPlatform.secondary.favorites'),
      route: classicUrl('personalisation/my-favourites'),
    },
    {
      id: 'radar-templates',
      label: t('crossPlatform.secondary.radarTemplates'),
      route: classicUrl('personalisation/my-radar-templates'),
    },
    {
      id: 'distribution',
      label: t('crossPlatform.secondary.distribution'),
      route: classicUrl('personalisation/my-preferences'),
    },
    {
      id: 'language',
      label: t('crossPlatform.secondary.language'),
      route: classicUrl('personalisation/my-language'),
    },
    {
      id: 'default-gender',
      label: t('crossPlatform.secondary.defaultGender'),
      route: `/${locale}/settings/default-gender`,
    },
    {
      id: 'collection-status',
      label: t('crossPlatform.secondary.collectionStatus'),
      route: classicUrl(`status/match-status/${DEFAULT_COMPETITION_ID}`),
    },
    {
      id: 'logout',
      label: t('crossPlatform.secondary.logout'),
      onClick: logout,
    },
  ];
};
